
        import Mathjax from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/mathjax/js/mathjax';  
const main = (UX) => {
    const $mathjax = Array.prototype.slice.call(document.querySelectorAll('article[data-enable-mathjax="true"] ,[data-mathJax] , .mathStatement , .inline-equation , math'))

try {
        if ($mathjax.length ) {
            UX.mathjax = new Mathjax($mathjax)
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        